import { Link } from "react-router-dom"

const Error = ()=>{
    return (
        <>
        <div style={{marginTop:"3rem"}} className="container">
        <h2>What exactly are you looking for?</h2>
        <h1>This is an error page 404</h1>
        <Link to="/">Go Back Home</Link>
        </div>
        </>
    )
}

export default Error;